// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__4-x5X","col":"styles_col__NKlXA","actions":"styles_actions__3lsy3","conflict":"styles_conflict__3SJWb"};